import React from "react";
import ProjectCard from "../components/ProjectCard";

function Project() {
  return (
    <div className="flex flex-wrap items-center justify-center flex-col lg:flex-row relative overflow-hidden ">
      {/* <img
        src="./star.jpg"
        alt=""
        className="h-full w-full object-cover opacity-20 absolute bottom-0"
      /> */}
      <div className="z-20 flex items-center justify-center gap-3 m-2 flex-wrap">
        <ProjectCard
          name={"College Management System"}
          image={"/project/clg-mac.png"}
          about={
            "A comprehensive college management system catering to administrators, students, and teachers, facilitating seamless communication, academic management, and administrative tasks."
          }
          demo={"https://friendly-cranachan-15d5c9.netlify.app/"}
          code={"https://github.com/omeher26/SMSWebAppFrontend"}
        />
        <ProjectCard
          name={"File Sharing Application"}
          image={"/project/file-share-mac.png"}
          about={
            "Empower your file sharing experience with our intuitive web app. Effortlessly upload, share, and collaborate on files with friends, all in one secure platform."
          }
          demo={"https://fastidious-kangaroo-d4cb55.netlify.app/"}
          code={"https://github.com/omeher26/file-sharing-frontend"}
        />
        <ProjectCard
          name={"UserSphere"}
          image={"/project/user-management-mac.png"}
          about={
            "Effortlessly store and manage user information in our React-based web application. Seamlessly organize user data for enhanced efficiency and accessibility."
          }
          demo={"https://soft-meerkat-ad8601.netlify.app/"}
          code={"https://github.com/omeher26/Users-Management-Web-Application"}
        />
        <ProjectCard
          name={"Mandap Community App"}
          image={"/project/mandap-mobile-app3.jpg"}
          about={
            "Introducing Mandap Community: A dynamic React Native app facilitating seamless event management associations, fostering collaboration among organizers. Connect, collaborate, and elevate event planning experiences with our innovative platform."
          }
          demo={"https://drive.google.com/file/d/1WH-VRISqNjkeO_tAnRJxvs3MigNE4P_8/view?usp=drive_link"}
          code={"https://github.com/omeher26/newapp-Mandap"}
        />

        <ProjectCard
          name={"ECOMMERCE STORE"}
          image={"/project/ecommerce-store-web-mac.png"}
          about={
            "Explore our chic e-commerce hub offering curated fashion, footwear, jewelry, and fragrances. Elevate your style effortlessly with our diverse selection for men and women."
          }
          demo={"https://benevolent-profiterole-5bda68.netlify.app/"}
          code={"https://github.com/omeher26/Ecommerce-store-web-application"}
        />
        <ProjectCard
          name={"Gym App"}
          image={"/project/gym-mobile-app32.jpg"}
          about={
            "Discover comprehensive workout routines tailored for beginners, intermediates, and advanced fitness enthusiasts in our React Native gym exercise app."
          }
          demo={"https://drive.google.com/file/d/1W1vNLlC8jBkoXMUeKsaiZpddvffJuw5e/view?usp=drive_link"}
          code={"https://github.com/omeher26/gym-react-native"}
        />

        <ProjectCard
          name={"FREELANCER WEBSITE UI"}
          image={"/project/freelancer-web-mac.png"}
          about={
            "Experience a seamless platform connecting freelancers with projects, designed with intuitive UI and React technology for efficient collaboration."
          }
          demo={"https://merry-lolly-8b020c.netlify.app/"}
          code={"https://github.com/omeher26/FreelancerWebUI"}
        />
        <ProjectCard
          name={"STARTUP JOB FINDER"}
          image={"/project/job-finder-web-mac.png"}
          about={
            "Find your next startup adventure on our streamlined job finder platform. Explore curated listings tailored for ambitious individuals seeking innovation. Empower your career journey with ease and precision."
          }
          demo={"https://enchanting-longma-74226d.netlify.app/"}
          code={"https://github.com/omeher26/jobFinderUI"}
        />
        <ProjectCard
          name={"CORPORATE"}
          image={"/project/corporate-web-mac.png"}
          about={
            "Discover our corporate essence through our meticulously crafted website, powered by React, HTML, CSS, and JavaScript. Explore our professional services and achievements in a sleek, Bootstrap-enhanced design."
          }
          demo={"https://exquisite-banoffee-df9214.netlify.app/"}
          code={"https://github.com/omeher26/corporateReactproject"}
        />
        <ProjectCard
          name={"FOODIE"}
          image={"/project/res-web-mac.png"}
          about={
            "Elegant and user-friendly, responsive restaurant website UI, crafted for effortless browsing. Engage customers with visually captivating design."
          }
          demo={"https://gleeful-starship-5ea9ba.netlify.app/"}
          code={"https://github.com/omeher26/RestaurantWeb.github.io"}
        />
      </div>
    </div>
  );
}

export default Project;
